/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Store from '@ember-data/store';
import type AIAgentSetupService from 'embercom/services/ai-agent-setup-service';

export default class FinAIAgentDeployEmailRoute extends Route {
  @service declare intl: IntlService;
  @service declare store: Store;
  @service declare aiAgentSetupService: AIAgentSetupService;

  get titleToken() {
    return this.intl.t('ai-agent.deploy.email');
  }

  async model() {
    this.aiAgentSetupService.channelType = 'email';
    await this.store.findAll('template');
  }
}
